<template>
  <v-app light class="no-border">
    <v-content> 
      <!-- top toolbar START -->
      <v-toolbar>
        <v-toolbar-title>
           <img src="@/assets/img/Logotype_Light.png" height="38px"></img>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items class="">
          <v-btn text to="/signin">Sign in</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <!-- top toolbar END -->

      <v-container fill-height>
          <v-layout row wrap>
          <v-flex xs12>
          </v-flex>
          <!-- email activated text START -->
          <v-flex v-if="result === 'ok'" xs12 sm6 offset-sm3 class="text-xs-center">
            <h1 class="display-3">Your email is being activated !</h1>
            <h3> Please wait a few moments </h3>
          </v-flex>
          <!-- email activated text END -->

          <!-- error email activated text START -->
          <v-flex v-if="result === 'Not found.'" xs12 sm6 offset-sm3 class="text-xs-center">
            <h1 class="display-3">Error when activating your email</h1>
            <h3> Send a new email by <v-btn text @click.native="resendEmail">clicking here.</v-btn></h3>
          </v-flex>
          <!-- error email activated text END -->
        </v-layout>
      </v-container>
    </v-content>
    <content-footer></content-footer>
    <notify/>
  </v-app>
</template>
<script>
	import AccountService from './services/AccountService'
  	
  	export default {
	    data: function() {
	      return {
          result: String,
	      }
	    },
	    created: function() {
  			var key = this.$route.params.key
  			AccountService.email_validation(key, this)
        var status = this.$route.params.status
		  },
	    methods: {
        resendEmail(){
        /*AccountService.emailNotReceived(this.userInput, this)*/
        console.log('resendEmail methods - TODO')
      }
	    }
	}
</script>
<style>
</style>